/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiDefInvitationData } from '../../models/api-def-invitation-data';

export interface OrganizationsGetPendingInvitations$Params {

/**
 * The ID of the organization
 */
  organizationId: string;
}

export function organizationsGetPendingInvitations(http: HttpClient, rootUrl: string, params: OrganizationsGetPendingInvitations$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ApiDefInvitationData>>> {
  const rb = new RequestBuilder(rootUrl, organizationsGetPendingInvitations.PATH, 'get');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ApiDefInvitationData>>;
    })
  );
}

organizationsGetPendingInvitations.PATH = '/organizations/{organizationId}/users/invitations';
